export default __webpack_public_path__ + "static/Lato-Semibold-f1405bd8a987c2ea8a67be8c371af61b.woff2";